/**
 * StorageProvider 注入点（docs/09 §6.2）。
 * 默认本地实现；P1 登录态为云时 setStorageProvider(new CloudStorageProvider(...)) 即完成切换。
 */
import type { StorageProvider } from '@f3b/shared'
import { LocalStorageProvider } from './localStorageProvider'

let current: StorageProvider = new LocalStorageProvider()

export function getStorage(): StorageProvider {
  return current
}

export function setStorageProvider(provider: StorageProvider): void {
  current = provider
}
